import { Injectable } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FullPageSpinnerComponent} from '../../../shared/dialogs/full-page-spinner/full-page-spinner.component';
import {WatchlistsService} from './watchlists.service';
import {
  AddToWatchlistConfirmationDialogComponent
} from '../../../shared/dialogs/add-to-watchlist-confirmation-dialog/add-to-watchlist-confirmation-dialog.component';
import {finalize, catchError, tap} from 'rxjs/operators';
import {defer, EMPTY, iif, of} from 'rxjs';
import {DialogService} from '../dialog.service';

@Injectable({
  providedIn: 'root'
})
export class AddToWatchlistManagerService {
  loader: MatDialogRef<FullPageSpinnerComponent> | null = null;

  constructor(
    private dialog: MatDialog,
    private watchlistsService: WatchlistsService,
    private dialogService: DialogService
  ) { }

  addToWatchlist(isin: string): void {
    iif(
      () => this.watchlistsService.userWatchlists === undefined,
      defer(() => {
        this.showLoader();
        return this.watchlistsService
          .getUserWatchlists()
          .pipe(
            finalize(() => this.hideLoader()),
            catchError(error => {
              const message: string = error.status === 403
                ? 'Accesso alla risorsa non consentito.'
                : 'C\'è stato un problema temporaneo. Riprova più tardi.';
              this.dialogService.openFailureSnackBar(message);
              return EMPTY;
            })
          );
      }),
      of(this.watchlistsService.userWatchlists)
    )
    .pipe(
      tap(watchlists => {
        if (!watchlists || watchlists.length === 0) {
          this.dialogService.openWarningSnackBar('Crea prima una watchlist per aggiungervi dei certificati');
          return;
        }

        const addToWatchlistDialogRef = this.dialog.open(AddToWatchlistConfirmationDialogComponent, {
          data: { isin, watchlists },
          disableClose: true,
          panelClass: 'add-to-watchlist-confirmation-dialog',
        });

        addToWatchlistDialogRef.componentInstance.addToWatchlist = (
          watchlistId: number,
          setLoading: (isLoading: boolean) => void
        ) => {

          setLoading(true);

          this.watchlistsService.canAddCertificate(watchlistId, isin)
            .subscribe(
              canAdd => {
                if (!canAdd) {
                  addToWatchlistDialogRef.close();
                  this.dialogService.openWarningSnackBar('Isin già presente nella watchlist');
                  return;
                }

                this.watchlistsService.addCertificate(watchlistId, [isin])
                  .subscribe(
                    () => {
                      addToWatchlistDialogRef.close();
                      this.dialogService.openSuccessSnackBar('Isin inserito con successo nella watchlist');
                    },
                    () => {
                      addToWatchlistDialogRef.close();
                      this.dialogService.openFailureSnackBar('Inserimento nella watchlist non riuscita. Riprova più tardi');
                    }
                  );
              },
              error => {
                switch (error.status) {
                  case 403:
                    addToWatchlistDialogRef.close();
                    this.dialogService.openFailureSnackBar('Non sei autorizzato ad aggiungere isin in questa watchlist');
                    break;
                  default:
                    addToWatchlistDialogRef.close();
                    this.dialogService.openFailureSnackBar('Inserimento nella watchlist non riuscita. Riprova più tardi');
                    break;
                }
              }
            );
        };
      })
    )
    .subscribe();
  }

  private showLoader = () => {
    this.loader = this.dialog.open(FullPageSpinnerComponent, {
      disableClose: true,
      panelClass: 'full-page-spinner',
    });
  }

  private hideLoader = () => {
    this.loader.close();
    this.loader = null;
  }
}
